$(document).ready(function() {
  var $slider = $('.slick-slider');
  var wheelTimeout = null;
  var lastWheelTime = 0;
  var isScrolling = false;

  // 1. REMOVE EMPTY & PLACEHOLDER SLIDES
  $slider.children().filter(function() {
    var $this = $(this);
    var isEmpty = $.trim($this.html()) === "";
    var isPlaceholder = $this.find('img[src*="no-image"]').length > 0;
    return isEmpty || isPlaceholder;
  }).remove();

  // 2. INITIALIZE SLIDER
  $slider.slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    // --- Autoplay Restored ---
    autoplay: false,
    autoplaySpeed: 2500,
    // -------------------------
    arrows: false,
    dots: false,
    centerMode: true,
    centerPadding: '20%', // Makes slide smaller to match screenshot

    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerPadding: '40px',
          dots: true
        }
      }
    ]
  });

  // 3. TOUCHPAD HORIZONTAL SCROLL CONTROL (Added for laptop/macbook touchpads)
  function handleTouchpadWheel(e) {
    const dx = e.originalEvent.deltaX || 0;
    const dy = e.originalEvent.deltaY || 0;

    // Only react if horizontal movement is dominant
    if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 30) {
      e.preventDefault();
      e.stopPropagation();

      if (dx > 0) {
        $(this).slick('slickNext');
      } else {
        $(this).slick('slickPrev');
      }
      return false;
    }
    return true;
  }

  // 4. MOUSE WHEEL CONTROL - FIXED FOR SAFARI (Vertical scroll)
  $slider.on('wheel', function(e) {
    const dx = e.originalEvent.deltaX || 0;
    const dy = e.originalEvent.deltaY || 0;
    
    // Check if this is a horizontal touchpad gesture
    if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 30) {
      // Handle horizontal touchpad movement
      return handleTouchpadWheel.call(this, e);
    }
    
    // Otherwise handle vertical wheel scrolling (existing functionality)
    e.preventDefault();
    e.stopPropagation();
    
    var now = Date.now();
    var delta = dy;
    
    // Clear previous timeout if exists
    if (wheelTimeout) {
      clearTimeout(wheelTimeout);
    }
    
    // Check if this is part of momentum scrolling
    // Safari fires wheel events with very small time differences during momentum
    if (now - lastWheelTime < 150) {
      // If we're already scrolling, ignore additional events
      if (isScrolling) {
        return false;
      }
    }
    
    // Update last wheel time
    lastWheelTime = now;
    
    // Set scrolling flag
    isScrolling = true;
    
    // Determine direction based on delta
    if (delta < 0) {
      $(this).slick('slickPrev');
    } else if (delta > 0) {
      $(this).slick('slickNext');
    }
    
    // Reset scrolling flag after a delay
    wheelTimeout = setTimeout(function() {
      isScrolling = false;
    }, 200);
    
    return false;
  });
  
  // Additional fix for Safari's touchpad gestures
  // Prevent multiple triggers during gesture
  $slider.on('touchstart', function(e) {
    if (wheelTimeout) {
      clearTimeout(wheelTimeout);
    }
    isScrolling = true;
  });
  
  $slider.on('touchend', function(e) {
    setTimeout(function() {
      isScrolling = false;
    }, 200);
  });
});



document.addEventListener("DOMContentLoaded", function () {
  const details = document.getElementById('Details-menu-drawer-container');
  const summary = details.querySelector('summary');
  const closeButton = details.querySelector('.menu-drawer__close-button');
  const backdrop = details.querySelector('.menu-drawer__backdrop');

  // CONFIGURATION: Adjust this number to match your CSS animation speed (usually 300-500ms)
  const animationTime = 400; 

  // --- Helper Functions --- 

  function openMenu() {
    // 1. Force the details to be open so the element exists in DOM
    details.open = true;
    
    // 2. Add attributes that trigger the CSS slide-in animation
    summary.setAttribute("aria-expanded", "true");
    details.classList.add("menu-opening");
  }

  function closeMenu() {
    // 1. Remove the visual "open" classes first (triggers the slide-out animation)
    summary.setAttribute("aria-expanded", "false");
    details.classList.remove("menu-opening");
    details.classList.add("menu-closing");

    // 2. CRITICAL: Wait for the animation to finish, THEN remove the element
    setTimeout(() => {
      details.open = false;
      details.classList.remove("menu-closing");
    }, animationTime);
  }

  // --- Event Listeners ---

  // 1. Toggle Button (Summary)
  summary.addEventListener("click", function (e) {
    e.preventDefault(); // Stop default instant toggle
    if (details.open) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  // 2. Close 'X' Button
  if (closeButton) {
    closeButton.addEventListener("click", function (e) {
      e.preventDefault();
      closeMenu();
    });
  }

  // 3. Background/Backdrop click
  if (backdrop) {
    backdrop.addEventListener("click", function (e) {
      e.preventDefault();
      closeMenu();
    });
  }
});


document.addEventListener('DOMContentLoaded', function() {
  const currentPath = window.location.pathname;
  
  // Function to update active classes
  function updateActiveClasses() {
    console.log('Updating active classes for path:', currentPath);
    
    // Update desktop menu
    updateMenuLinks('.menu-list__link[href]', 'menu-list__link--active');
    
    // Update mobile menu (inside drawer)
    updateMenuLinks('.menu-drawer__menu-item[href]', 'menu-drawer__menu-item--active');
  }
  
  function updateMenuLinks(selector, activeClass) {
    document.querySelectorAll(selector).forEach(link => {
      const href = link.getAttribute('href');
      
      // Remove existing active class
      link.classList.remove(activeClass);
      
      // Skip problematic hrefs
      if (!href || href === '#' || href.startsWith('javascript:')) return;
      
      let linkPath;
      try {
        linkPath = new URL(href, window.location.origin).pathname;
      } catch(e) {
        linkPath = href; // Use as-is for relative URLs
      }
      
      // Check if this link should be active
      if (shouldBeActive(linkPath)) {
        link.classList.add(activeClass);
        console.log(`✓ Added ${activeClass} to:`, href);
      }
    });
  }
  
  function shouldBeActive(linkPath) {
    // Exact match
    if (currentPath === linkPath) {
      return true;
    }
    
    // Product page -> Shop link (collections)
    if (currentPath.includes('/products/') && linkPath.includes('/collections/')) {
      return true;
    }
    
    // Collection page -> Shop link (all-product)
    if (currentPath.includes('/collections/') && 
        (linkPath === '/collections/all-product' || linkPath === '/collections/all')) {
      return true;
    }
    
    // Collection page -> matching collection
    if (currentPath.includes('/collections/') && linkPath.includes('/collections/')) {
      const currentCollection = currentPath.split('/collections/')[1]?.split('/')[0];
      const linkCollection = linkPath.split('/collections/')[1]?.split('/')[0];
      
      if (currentCollection === linkCollection) {
        return true;
      }
    }
    
    return false;
  }
  
  // Initial update
  updateActiveClasses();
  
  // Listen for drawer state changes
  const drawer = document.querySelector('header-drawer');
  if (drawer) {
    // Use MutationObserver to watch for 'open' attribute changes
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          console.log('Drawer opened/closed');
          updateActiveClasses();
        }
      });
    });
    
    // Watch the details element inside header-drawer
    const details = drawer.querySelector('details');
    if (details) {
      observer.observe(details, {
        attributes: true,
        attributeFilter: ['open']
      });
    }
  }
  
  // Also update when clicking menu toggle
  document.addEventListener('click', function(e) {
    const toggle = e.target.closest('.header__icon--menu, [on\\:click*="toggle"]');
    if (toggle) {
      setTimeout(updateActiveClasses, 100);
    }
  });
  
  // Run again after a short delay to ensure everything is loaded
  setTimeout(updateActiveClasses, 500);
  setTimeout(updateActiveClasses, 1000);
});